export enum SelectDropdownOptions {
  auto = "auto",
  bottom = "bottom",
  top = "top",
}
